import React from "react";

interface ExitConversationModeProps {
  onExit: () => void;
}

const ExitConversationMode: React.FC<ExitConversationModeProps> = ({
  onExit,
}) => {
  return (
    <div className="px-4 py-3 pt-4 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="relative bg-transparent">
            <div className="w-5 h-5 bg-red-500 rounded-full animate-ping absolute"></div>
            <div className="w-5 h-5 bg-red-500 rounded-full"></div>
          </div>
          <div className="flex flex-col">
            <span className="text-lg font-medium text-gray-700">
              Transcribing Speech...
            </span>
            <span className="text-xs text-gray-500">
              Say 'Exit Hands-Free Mode' to exit.
            </span>
          </div>
        </div>
        <button
          onClick={onExit}
          className="px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base text-[#46ACC6] bg-white/20 hover:bg-white/30 border border-[#46ACC6]/40 hover:border-[#46ACC6]/60 rounded-md transition-all duration-300 hover:shadow-lg hover:scale-102 font-medium backdrop-blur-sm flex items-center space-x-2"
          aria-label="Exit hands-free mode"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
          <span>Exit</span>
        </button>
      </div>
    </div>
  );
};

export default ExitConversationMode;
